const SLOTS_PREF_KEY = "user_slots_preference";

export type SlotsPref = "fixed" | "free";

export const getSlotsPref = (): SlotsPref | null =>
  localStorage.getItem(SLOTS_PREF_KEY) as SlotsPref | null;

export const setSlotsPref = (pref: SlotsPref): void =>
  localStorage.setItem(SLOTS_PREF_KEY, pref);

/**
 * Determines whether calendar-based (fixed/schedule) slots should be used.
 *
 * Priority:
 * - If localStorage key is absent (null) → fall back to the genie flag `slotsFromDoctorCalendar`
 * - If localStorage is explicitly "fixed" → true (use calendar slots)
 * - If localStorage is explicitly "free" → false (never use calendar slots, even if genie flag is on)
 */
export function getShouldShowCalendarSlots(
  slotsFromDoctorCalendar: boolean
): boolean {
  const lsValue = getSlotsPref();
  if (lsValue === null) return slotsFromDoctorCalendar;
  return lsValue === "fixed";
}
